module.exports = __webpack_public_path__ + "img/img_emptyschedule.4b05f885.png";